/**
 * Meta Pixel — código base oficial.
 * Se ejecuta una sola vez por carga de página, antes del render de la app.
 */
const PIXEL_ID = '1555663492362726'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel(pixelId: string = PIXEL_ID): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized || window.fbq) {
    initialized = true
    return
  }
  initialized = true

  /* eslint-disable */
  // Snippet base de Meta (fbevents.js)
  ;(function (f: any, b: Document, e: string, v: string) {
    let n: any, t: any, s: any
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e) as HTMLScriptElement
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')

  // Fallback <noscript> del código base
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}
